export default {"src":"/_next/static/media/youtube.103e9a99.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};